
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/regulamin-pracodawcy",
      function () {
        return require("private-next-pages/regulamin-pracodawcy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/regulamin-pracodawcy"])
      });
    }
  